// src/maintenance.config.ts
/**
 * Maintenance configuration
 * This file is used to configure the maintenance mode of the application.
 * It is used to set the start time, estimated duration, message, and contact email for the maintenance mode.
 * It is also used to set the enabled flag to true or false to enable or disable the maintenance mode.
 * be careful not to commit this file to the repository with unintended changes.
 */

export type MaintenanceMode = 'maintenance' | 'incident' | 'resolved';

export interface IMaintenanceConfig {
  enabled: boolean;
  mode: MaintenanceMode; // 'maintenance' = full downtime page; 'incident' = banner only, app stays up
  startTime: string; // ISO 8601: '2026-04-15T02:00:00Z' — used for maintenance mode scheduling
  estimatedDuration: string; // human-readable: '~2 hours' — used for maintenance mode
  contactEmail: string; // 'support@exim.com'
  message: string; // custom message shown in the incident banner; leave empty for default text
}

export const maintenanceConfig: IMaintenanceConfig = {
  enabled: false,
  mode: 'resolved',
  startTime: '2026-06-03T10:30:00Z',
  estimatedDuration: '',
  contactEmail: 'helpdesk@shipsy.io',
  message: "We apologize for the duplicate DSR emails received earlier due to a queueing issue; the problem has been resolved, all pending outdated emails have been cleared from the queue, and normal email delivery has been restored.",
};
